import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";

import { type EventOverview } from "@/schemas/events/EventOverview";
import { themes } from "@/Components/Styling/themeConfigs";

type Props = {
  event: EventOverview;
  onPress: (eventId: string) => void;
};

function ViewDetails({ event, onPress }: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      marginTop: 16,
      paddingTop: 16,
      borderTopWidth: 1,
      borderTopColor: currentTheme.borderColor,
      flexDirection: "row",
      justifyContent: "flex-end", // Align to the right
    },
    right: {
      flexDirection: "row",
      gap: 4,
    },
    text: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
    },
  });

  return (
    <View style={styles.container}>
      <Pressable onPress={() => onPress(event.id)}>
        <View style={styles.right}>
          <Text style={styles.text}>More Details</Text>
          <MaterialIcons
            name="chevron-right"
            size={currentTheme.icon.size.web.medium}
            color={currentTheme.typography.h1.color}
          />
        </View>
      </Pressable>
    </View>
  );
}

export default ViewDetails;
